import WarningModal from 'components/Modal/WarningModal';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

export function RouterPrompt({ when }: { when: boolean }) {
  const history = useHistory();
  const { t } = useTranslation();

  const [showPrompt, setShowPrompt] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  const unblockRef = useRef<any>();

  function handleShowModal() {
    setShowPrompt(true);
  }

  function onCancel() {
    setShowPrompt(false);
  }

  useEffect(() => {
    unblockRef.current = history.block((location) => {
      if (when) {
        setCurrentPath(location.pathname);
        handleShowModal();
        return false;
      }
      return true as any;
    });
    return () => {
      unblockRef.current && unblockRef.current();
    };
  }, [when]);

  function handleConfirm() {
    if (unblockRef) {
      unblockRef.current();
    }
    setShowPrompt(false);
    history.push(currentPath);
  }

  return showPrompt ? (
    <WarningModal
      isOpen={showPrompt}
      dataBody={t('common.warningChange')}
      btnAction={t('common.continue')}
      onClose={onCancel}
      onAction={handleConfirm}
      color='red'
    />
  ) : null;
}
